<div class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <span>
        <h1 class="screen-title">{{ screentitle }}</h1>
      </span>
      <span style="width: 100%; text-align: center;" *ngIf="Errmessage != ''">
        <p style="text-align: center; color: red; " class="errMsg">{{ Errmessage }}</p>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 4% 2% 2%">
                  <div>
                    <div>
                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input id="did" #input3 matInput [(ngModel)]="searchDetails.bookingdate_from"
                            [matDatepicker]="pickerFrom1" (dateChange)="toggleDisable2();incresedate();isEmpty();"
                            [disabled]="bookingdate" autocomplete="off" placeholder="From Date" readonly
                            [max]="myDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset3(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                      </div>

                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input [min]="final" #input4 matInput [disabled]="bookingdate"
                            [(ngModel)]="searchDetails.bookingdate_to" [matDatepicker]="pickerTO"
                            (dateChange)="isEmpty();" autocomplete="off" placeholder="To Date" readonly
                            [max]="newDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTO></mat-datepicker>
                        </mat-form-field>
                        <button type="button" class="close opa" (click)="reset4(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                        <span *ngIf="invaliddate" style="color: red;font-size: 10px">
                          'To' date should be greater than 'From' date
                        </span>
                      </div>
                    </div>

                    <div class="sdiv">
                      <div class="btn clear-button button-margin">
                        <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyValue == false"
                          (click)="searchData()" type="button">
                          <em class="fa fa-search "></em>&nbsp;Search
                        </button>
                      </div>
                    </div>
                    <div class="sdiv">
                      <div class="btn clear-button button-margin">
                        <button class="btn btn-primary  commonbutt" [disabled]="sendEmailReports.length == 0"
                          (click)="sendDsrEmail()" type="button">
                          <em></em>&nbsp;Send Email
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clr"></div>


              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                [hidden]="searchlist">
                <table aria-describedby="dsrReportDetails" class="table table-striped" *ngIf="!loader"
                  [mfData]="serachtabledata" [mfRowsOnPage]="6">
                  <thead>
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Send Mail</th>
                      <th scope="col">DSR Report</th>
                      <th scope="col">Email Status</th>
                      <th scope="col">Date & Time</th>
                      <th scope="col">Total Sales</th>
                      <th scope="col">No of Tickets Issued</th>
                      <th scope="col">Total Refunded</th>
                      <th scope="col">No of Tickets Refunded</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="link" *ngFor="
                        let item of (search_detail_list
                          | paginate: { itemsPerPage: 10, currentPage: p ,totalItems:totalItems })
                      ">
                      <td>
                        {{item.REPORT_DATE}}
                      </td>
                      <td>
                        <input type="checkbox"
                          (change)="sendMailCheck($event,item.REPORT_NAME,item.ID,item.NEW_CREATED_DATE)">
                      </td>
                      <td>
                        <a (click)="downloadDsr(item.REPORT_NAME,item.NEW_CREATED_DATE)"> {{item.REPORT_NAME}} </a>
                      </td>
                      <td *ngIf="item.IS_EMAIL_SENT == 1">Sent</td>
                      <td *ngIf="item.IS_EMAIL_SENT == 0">Not Sent</td>
                      <td>
                        {{ item.CREATED_DATE }}
                      </td>
                      <td>
                        {{ item.TOTAL_SALES_AMOUNT }}
                      </td>
                      <td>
                        {{ item.TOTAL_SALES_TICKET }}
                      </td>
                      <td>
                        {{ item.TOTAL_REFUNDED_AMOUNT }}
                      </td>
                      <td>
                        {{ item.TOTAL_REFUNDED_TICKET }}
                      </td>

                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                        </pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                  {{ noresult }}
                </h1>
              </div>
              <div *ngIf="loader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>